import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useLink } from 'react-aria';
import { NavLink as RRDNavLink } from 'react-router';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './NavLink.module.scss';

const NavLink = ({ children, className, to, role, target, isDisabled, inverse, underline, rel, ...props }) => {
    const ref = useRef();
    const { linkProps } = useLink(props, ref);

    return (
        <RRDNavLink
            ref={ref}
            {...linkProps}
            className={[
                'govuk-link',
                isDisabled ? styles.disabled : null,
                inverse ? 'govuk-link--inverse' : null,
                !underline ? 'govuk-link--no-underline' : null,
                styles.link,
                className
            ].join(' ')}
            to={to}
            rel={rel}
            target={target}
            role={role}
        >
            {children}
        </RRDNavLink>
    );
};

NavLink.propTypes = {
    ...defaultAriaProps,
    to: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
    inverse: PropTypes.bool,
    underline: PropTypes.bool,
    rel: PropTypes.string,
    lang: PropTypes.string,
    role: PropTypes.string
};

NavLink.defaultProps = {
    inverse: false,
    underline: true
};

export default NavLink;
